export class EventOptionsModel {
  isPublic: boolean = true;
  eventResponseDays: number = 3;

  /**
   * „Im Dienstplan ausblenden" — keep every occurrence of this event off the Dienstplan board.
   *
   * Defaults to `false`: the board is where a new event is expected to show up, and an option that hid things
   * by default would be discovered by their absence.
   */
  hideInShiftMaker: boolean = false;
}
